/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IEstimationHistoryTitle {
  /** Заголовок для графика **/
  title: string;
  /** Процент изменения оценки **/
  changeValue?: TEstimationHistoryTitle_ChangeValue;
  /** Изменение оценки (увеличение/уменьшение/без изменений) **/
  change: EChange;
}

export type TEstimationHistoryTitle_ChangeValue = null | string;

export enum EChange {
  /** Оценка снизилась **/
  'Decrease' = 'decrease',
  /** Оценка увеличилась **/
  'Increase' = 'increase',
  /** Оценка не изменилась **/
  'NotChanged' = 'notChanged',
}
